import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostLockAllCustomerUsersRequest = {
	customerId?: number;
	shardName?: string;
};

export const postLockAllCustomerUsers = createPostEndpoint<PostLockAllCustomerUsersRequest, void>(
	(request) => `/api/v3/core/customers/${request?.customerId ?? 'current'}/lock-all-users`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
